import { Serializable } from '../../../core/models/serializable';

export class CustomerEventModel implements Serializable<CustomerEventModel> {
  fromObject(obj: any): CustomerEventModel {
    Object.assign(this, obj);
    return this;
    //throw new Error("Method not implemented.");
  }
  toObject() {
    return {
      EventParticipantId: this.eventParticipantId,
      EventId: this.eventId,
      Name: this.name,
      StartDate: this.startDate,
      EndDate: this.endDate,
      PackageName: this.packageName,
    };
  }

  public eventParticipantId: number;
  public eventId: number;
  public name: string;
  public startDate: Date;
  public endDate: Date;
  public packageName: string;
  public isActive: boolean;
  public eventCvDatabaseAccessNotGranted: boolean;
}
